module.exports = __webpack_public_path__ + "img/Documents2.2a39c3a5.svg";